import { CreditCardBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';
import creditCardType from 'credit-card-type';
import { CardFocusType } from '../../../constants/CardFocusType';
import { useEffect } from 'react';
import { CardType } from '../../../constants/CardType';

interface CardNumberParameters {
    disabled: boolean;
}

export const CardNumber: React.FC<CardNumberParameters> = ({ disabled }) => {
    const cardNumber = usePaymentStore((s) => s.cardNumber);
    const set_cardNumber = usePaymentStore((s) => s.set_cardNumber);
    const set_cardFocus = usePaymentStore((s) => s.set_cardFocus);
    const set_cardType = usePaymentStore((s) => s.set_cardType);

    useEffect(() => {
        let cardType: CardType | undefined = undefined;

        if (!cardNumber) {
            set_cardType(undefined);
            return;
        }

        const numbersOnly = cardNumber.replace(/[ _]/g, '');
        const cardTypes = creditCardType(numbersOnly);

        if (cardTypes.length === 1) {
            cardType = cardTypes[0].niceType.toUpperCase() as CardType | undefined;
        }

        set_cardType(cardType);
    }, [cardNumber]);

    return (
        <CreditCardBox
            label='Card Number'
            name='card-number'
            value={cardNumber}
            onChange={(value) => set_cardNumber(value)}
            onFocusIn={() => set_cardFocus(CardFocusType.CardNumber)}
            disabled={disabled}
        />
    );
};
